import SiteCommand from "../../Site-Command/components/SiteCommand.vue";

export default [
  {
    path: "/SiteCommand/outputs",
    name: "Outputs",
    component: SiteCommand,
    meta: {
      requiresAuth: true,
      checkPermissions: true,
      module: "site_command",
      feature: "outputs",
      title: "CruzControl | Outputs"
    }
  },
  {
    path: "/SiteCommand/inputs",
    name: "Inputs",
    component: SiteCommand,
    meta: {
      requiresAuth: true,
      checkPermissions: true,
      module: "site_command",
      feature: "discrete_inputs",
      title: "CruzControl | Inputs"
    }
  },
  {
    path: "/SiteCommand/edl_list",
    name: "Equipment Dependency List",
    component: SiteCommand,
    meta: {
      requiresAuth: true,
      checkPermissions: true,
      module: "site_command",
      feature: "edl_cil",
      title: "CruzControl | Equipment Dependency List"
    }
  },
  {
    path: "/SiteCommand/cil_list",
    name: "Critical Infrastructure List",
    component: SiteCommand,
    meta: {
      requiresAuth: true,
      checkPermissions: true,
      module: "site_command",
      feature: "edl_cil",
      title: "CruzControl | Critical Infrastructure List"
    }
  },
  {
    path: "/SiteCommand/wash-packages/:subPage",
    name: "Wash Packages",
    component: SiteCommand,
    meta: {
      requiresAuth: true,
      checkPermissions: true,
      module: "site_command",
      feature: "wash_packages",
      title: (route) => {
        const map = {
          washes: "Wash Packages",
          upsells: "Upsells",
          overrides: "Retracts",
        }

        return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
      }
    }
  },
  {
    path: "/SiteCommand/assistance_tool/:subPage",
    name: "Assistance Tool",
    component: SiteCommand,
    meta: {
      requiresAuth: true,
      checkPermissions: true,
      module: "site_command",
      feature: "assistance_tool",
      title: (route) => {
        const map = {
          control_word: "Additional Features",
          omni_control: "Omni Control",
          // omni_vac: "Omni/Vacuum PID",
          airgate_tables: "Blower Flip & Airgate",
          mirror_bumps: "Mirror Bumps",
          dry_run: "Dry Run",
          conveyor_speed_selector: "Conveyor Speed",
          blower_flips: "Blower Flips",
          pid_attack_module: "PID Attack",
        }

        return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
        }
      },
    },
    {
        path: "/SiteCommand/setup-options",
        name: "Setup Options",
        component: SiteCommand,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_command",
          feature: "setup_options",
          title: "CruzControl | Setup Options"
        }
    },
    // {
    //     path: "/SiteCommand/equipment/:id",
    //     name: "Equipment",
    //     component: SiteCommand,
    //     meta: {
    //       requiresAuth: true,
    //       checkPermissions: true,
    //       module: "site_command",
    //       feature: "equipment",
    //       title: "CruzControl | Equipment"
    //     }
    // },
    {
      path: "/SiteCommand/internal_tools/:subPage",
      name: "Internal Tools",
      component: SiteCommand,
      meta: {
        requiresAuth: true,
        checkPermissions: true,
        internal: true,
        license: "super_user"
      }
    },
    {
        path: "/SiteCommand/maintenance-mode",
        name: "Maintenance Mode",
        component: SiteCommand,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_command",
          feature: "maintenance_mode",
          title: "CruzControl | Maintenance Mode"
        }
    },
    {
        path: "/SiteCommand/RequestLogs",
        name: "RequestLogs",
        component: SiteCommand,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_command",
          feature: "request_logs",
          title: "CruzControl | Request Logs"
        }
    },
    // {
    //     path: "/SiteCommand/demo",
    //     name: "Show Demo",
    //     component: SiteCommand,
    //     meta: {
    //       requiresAuth: true,
    //       checkPermissions: true,
    //       module: "site_command"
    //     }
    // },
    {
        path: "/SiteCommand/asset-graph",
        name: "Asset Graph",
        component: SiteCommand,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_command",
          feature: "outputs",
          title: "CruzControl | Asset Graph"
        }
    },
    {
        path: "/SiteCommand/asset-graph/:assetCode",
        name: "Asset Graph View",
        component: SiteCommand,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_command",
          feature: "outputs",
          title: "CruzControl | Asset Graph View"
        }
    },
    {
        path: "/SiteCommand",
        name: "Site Command",
        component: SiteCommand,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_command",
          title: "CruzControl | Site Command"
        }
    },
]